const BASE64_PATTERN = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

function tryParseJsonObject(text: string): Record<string, unknown> | null {
  try {
    const parsed = JSON.parse(text);
    return parsed && typeof parsed === "object" ? (parsed as Record<string, unknown>) : {};
  } catch {
    console.warn("bonusSheetParser: failed to parse JSON object");
    return null;
  }
}

function decodeBase64(value: string): string | null {
  try {
    return atob(value);
  } catch {
    console.warn("bonusSheetParser: failed to decode base64 value");
    return null;
  }
}

export function isValidBase64(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length > 0 && trimmed.length % 4 === 0 && BASE64_PATTERN.test(trimmed);
}

export function parseBonusSheetJsonData(jsonData?: string | null): Record<string, unknown> {
  if (!jsonData) return {};

  const trimmed = jsonData.trim();

  // parsing as plain JSON
  const parsedPlain = tryParseJsonObject(trimmed);
  if (parsedPlain) return parsedPlain;

  // Fall back to base64-encoded JSON
  if (!isValidBase64(trimmed)) return {};

  const decoded = decodeBase64(trimmed);
  if (!decoded) return {};

  return tryParseJsonObject(decoded) ?? {};
}

export function getBonusSheetJsonData(bonusDetails: unknown): string | null {
  if (!bonusDetails || typeof bonusDetails !== "object") {
    console.warn("bonusSheetParser: bonusDetails is missing or not an object");
    return null;
  }
  const details = bonusDetails as Record<string, unknown>;
  const sheet = details.bonusSheet;
  if (!sheet) {
    console.warn("bonusSheetParser: bonusSheet is missing");
    return null;
  }
  if (typeof sheet === "string") return sheet;
  if (typeof sheet !== "object") {
    console.warn("bonusSheetParser: bonusSheet is not a string/object");
    return null;
  }
  const sheetObj = sheet as Record<string, unknown>;
  const jsonData = sheetObj.jsonData ?? sheetObj.JsonData;
  if (typeof jsonData !== "string") {
    console.warn("bonusSheetParser: jsonData/JsonData is missing or not a string");
    return null;
  }
  return jsonData;
}
